// extracted by mini-css-extract-plugin
module.exports = {"content":"TextContent_content__2S5Bh","button":"TextContent_button__yrPL5","buttonDeskTop":"TextContent_buttonDeskTop__2lYN5","rotate":"TextContent_rotate__5L6BT"};